import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { LogikFieldsEnum } from '../../../shared/logik/constants/fields.constant';
import { isArray } from 'lodash';
import { updateConfiguration } from '../../widget/thunks/basic/updateConfiguration';
import { fetchPricingDetails } from '../../widget/thunks/basic/fetchPricingDetails';
import { fetchSets } from '../../widget/thunks/basic/fetchSets';
import logger from '../../../app/logger';

export interface RemoveDeprecatedDiscountsArgs {
    wallItemUniqueId: string;
}

export const removeWallItem = createAsyncThunk<
    void,
    RemoveDeprecatedDiscountsArgs,
    {
        state: RootState;
    }
>('pricing/remove-wall-item', async ({ wallItemUniqueId }, thunkAPI): Promise<void> => {
    const dispatch = thunkAPI.dispatch;
    const widgetState = thunkAPI.getState().widget;

    for (const wallItem of widgetState.configurationSets[LogikFieldsEnum.set_of_all_side_wall_items]) {
        if (wallItem.fields['wallItemUniqueID'].value === wallItemUniqueId) {
            let removedByThreekit = false;
            try {
                removedByThreekit = await window.RemoveItemToolInstance.removeItemByUniqueId(wallItemUniqueId);
            } catch (err: unknown) {
                logger.error(err);
                removedByThreekit = false;
            }

            if (removedByThreekit) {
                setTimeout(async () => {
                    await Promise.all([
                        dispatch(fetchPricingDetails()),
                        dispatch(
                            fetchSets({
                                uuid: widgetState.uuid!,
                                sets: [LogikFieldsEnum.set_of_all_side_wall_items],
                            }),
                        ),
                    ]);
                }, 1000);
            } else {
                const indexField = `set.${LogikFieldsEnum.set_of_all_side_wall_items}.index`;
                const index = wallItem.fields[indexField].value;
                //let size = widgetState.configurationFields[`set.${LogikFieldsEnum.set_of_all_side_wall_items}.size`].value;
                let size = widgetState.configurationSets[LogikFieldsEnum.set_of_all_side_wall_items].map((f) =>
                    f.fields[indexField].value.toString(),
                );

                if (size && isArray(size)) {
                    size = [...size];
                    size.splice(size.indexOf(String(index)), 1);

                    await dispatch(
                        updateConfiguration({
                            uuid: widgetState.uuid,
                            updates: [
                                {
                                    variableName: `set.${LogikFieldsEnum.set_of_all_side_wall_items}.size`,
                                    value: size,
                                },
                            ],
                            forceUpdate: true,
                        }),
                    ).unwrap();
                }
            }
        }
    }
});
